/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Error_Set_PasswordInputs */



/**
* | output |
* | --- |
* | "Failed to set password" |
*
* @param {Auth_Verify_Error_Set_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_error_set_password = /** @type {((inputs?: Auth_Verify_Error_Set_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Error_Set_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la définition du mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al establecer la contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao definir a senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile impostare la password")
	return /** @type {LocalizedString} */ ("Failed to set password")
});